import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';
import { Button } from 'app/src/elements/buttons';

import { cardStyles as styles } from './index';
import { SEND_SELLER_DETAIL_REPORT } from './queries';

const SalesReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();
  const [saleId, setSaleId] = useState();
  const [month, setMonth] = useState();

  const [sendSellerDetailReport] = useMutation(SEND_SELLER_DETAIL_REPORT);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'seller-detail-report',
      params: {
        'sale-id': saleId, 'seller-id': sellerId, 'month': month
      },
    });
  };

  const handleEmail = () => {
    if (!sellerId) { return; }

    if (confirm('Email Report to Seller?')) {
      sendSellerDetailReport({
        variables: { sellerId, saleId, month }
      });
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Seller Detail Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <select
        style={styles.select}
        onChange={(e) => setSellerId(e.target.value)}
      >
        <option key="seller-nil" value="">Select Seller</option>
        {data.sellers?.map(seller => (
          <option key={seller.id} value={seller.id}>
            {seller.fullDisplayName}
          </option>
        ))}
      </select>
      <Text style={styles.label}>Sale (optional):</Text>
      <select style={styles.select} onChange={(e) => setSaleId(e.target.value)}>
        <option key="sale-nil" value="">Select Sale</option>
        {data.sales?.map(sale => (
          <option key={sale.id} value={sale.id}>
            {sale.name}
          </option>
        ))}
      </select>
      <Text style={styles.label}>
        Month (choose any date in month, optional):
      </Text>
      <input
        style={styles.select}
        onChange={e => setMonth(e.target.value)}
        value={month || ''}
        type="date"
      />

      <DownloadButton handleDownload={handleDownload}>
        <Button
          label="Email"
          style={
            sellerId ? { width: 120 } : { backgroundColor: 'gray', width: 120 }
          }
          onPress={handleEmail}
        />
      </DownloadButton>
    </View>
  );
};

export default SalesReport;
